import { Property } from "../../../shared/interfaces/property.interface";
import { PropertyChartData } from "../interfaces/propertyChartData";

export interface PropertiesState {
  properties: Array<Property>; 
  propertyCharts: { [propertyId: number]: PropertyChartData }; // Dictionary of PropertyChartData keyed by property ID
}

export const initialPropertiesState: PropertiesState = {
  properties: [],
  propertyCharts: {} 
};
